import { useScrollFadeIn } from '../../../hooks/useScrollFadeIn';

export default function CTA() {
  const { ref, isVisible } = useScrollFadeIn({ delay: 450 });
  const handleReserve = () => {
    window.open('https://mever.design/products/mever-chair-pro-ver2', '_blank');
  };

  return (
    <section
      ref={ref}
      className={`py-20 md:py-48 px-5 md:px-10 bg-[#080808] transition-all duration-1000 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
    >
      <div className="max-w-4xl mx-auto px-0 md:px-4 text-center">
        {/* 限定バッジ */}
        <div className="mb-10 md:mb-16">
          <div className="inline-flex items-center px-5 py-2.5 md:px-6 md:py-3 bg-white/5 border border-white/10 text-white text-sm md:text-base font-semibold rounded-full">
            各色50脚限定予約販売
          </div>
        </div>

        {/* 価格表示 */}
        <div className="mb-12 md:mb-20">
          <div className="text-sm md:text-lg text-purple-400 mb-3 md:mb-4 font-medium px-4">先行予約&amp;3月末まで、今回のみの期間限定特別価格です。</div>
          <div className="text-5xl md:text-8xl font-black text-purple-400 mb-5 md:mb-6 tracking-tight">30%OFF</div>
          <div className="text-base md:text-2xl text-white/60 mb-2 md:mb-3">
            通常価格 <span className="line-through">¥128,700</span>
          </div>
          <div className="text-4xl md:text-7xl font-black text-white tracking-tight">¥89,650</div>
        </div>

        {/* CTAボタン */}
        <button
          onClick={handleReserve}
          className="group w-full md:w-auto inline-flex items-center justify-center gap-3 px-10 py-4 md:px-16 md:py-6 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white text-base md:text-xl font-bold rounded-full transition-all duration-300 shadow-2xl shadow-purple-500/20 hover:shadow-purple-500/40 transform hover:scale-105 active:scale-[0.97] whitespace-nowrap cursor-pointer min-h-[56px]"
        >
          <span>今すぐ予約する</span>
          <span className="w-5 h-5 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
            <i className="ri-arrow-right-line text-xl"></i>
          </span>
        </button>

        {/* 発送情報 */}
        <p className="mt-10 md:mt-16 text-sm md:text-base text-white/40 px-4">
          発送：4月下旬〜5月上旬より順次発送
        </p>
      </div>
    </section>
  );
}